import type { ReactNode } from 'react';

/** Marks every typed term inside `text`, so a row shows why it matched. */
export function highlight(text: string, query: string): ReactNode {
  const terms = query
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((t) => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
  if (terms.length === 0) return text;
  // split() with a capture group puts each match at an odd index.
  return text
    .split(new RegExp(`(${terms.join('|')})`, 'gi'))
    .map((part, i) => (i % 2 === 1 ? <mark key={i}>{part}</mark> : part));
}
